import React from "react";

const ActionIcon = ({ icon, click }) => (
  <a href="# " onClick={click}>
    <i className={icon} />
  </a>
);

export default ActionIcon;
